angular.module('rjmNg.services').factory 'promiseCache', [
  "$q"
  ($q) ->
    ###
    This service which allows requests to any function which returns a promise
    to be cached.

    Every call to this function must specify both a store key and a cache key.
    The store key is used to diffentiate between different places where the
    cache is being used, and the cache key is used to identify the unique
    arguments to the function.
    ###

    promiseCacheService = {}

    cachedResponsesByStore = {}
    pendingQueriesByStore = {}

    # Get an Object containing cached responses associated with a specific store
    # key. Create one if it does not exist.
    getCachedResponses = (storeKey) ->
      cachedResponses = cachedResponsesByStore[storeKey]
      unless cachedResponses?
        cachedResponses = {}
        cachedResponsesByStore[storeKey] = cachedResponses

      return cachedResponses

    # Get an Object containing pending queries associated with a specific store
    # key. Create one of it does not exist.
    getPendingQueries = (storeKey) ->
      pendingQueries = pendingQueriesByStore[storeKey]
      unless pendingQueries?
        pendingQueries = {}
        pendingQueriesByStore[storeKey] = pendingQueries

      return pendingQueries

    # Attempt to resolve the promise using a cached response. Returns true if
    # the promise was resolved, and false otherwise.
    getCachedResponse = (storeKey, cacheKey, maxAge, cacheRejectedPromises, deferred) ->
      cachedResponses = getCachedResponses(storeKey)
      cachedResponse = cachedResponses[cacheKey]

      unless cachedResponse?
        return false

      if maxAge?
        now = new Date()
        if now - cachedResponse.timestamp >= maxAge
          # Cache expired
          delete(cachedResponses[cacheKey])
          return false

      if cachedResponse.success
        deferred.resolve(cachedResponse.response)
        return true
      else if cacheRejectedPromises
        deferred.reject(cachedResponse.response)
        return true
      else
        return false

    # Attempt to use a pending query to resolve this response. Returns true if
    # the promise was resolved, and false otherwise.
    getPendingQuery = (storeKey, cacheKey, deferred) ->
      pendingQueries = getPendingQueries(storeKey)
      pendingQuery = pendingQueries[cacheKey]

      unless pendingQuery?
        return false

      pendingQuery.then (success) ->
        deferred.resolve(success)
      , (error) ->
        deferred.reject(error)

      return true

    # Build the object used to represent a cached response.
    getCacheObject = (success, response) ->
      response: response
      success: success
      timestamp: new Date()

    # Call a function (which accepts no arguments), and store the the result in
    # the cache.
    callFunctionAndCacheResult = (storeKey, cacheKey, funcToCall, deferred) ->
      pendingQueries = getPendingQueries(storeKey)
      cachedResponses = getCachedResponses(storeKey)

      promise = funcToCall()
      pendingQueries[cacheKey] = promise

      promise.then (successResponse) ->
        cachedResponses[cacheKey] = getCacheObject(true, successResponse)
        delete(pendingQueries[cacheKey])
        deferred.resolve(successResponse)
      , (errorResponse) ->
        cachedResponses[cacheKey] = getCacheObject(false, errorResponse)
        delete(pendingQueries[cacheKey])
        deferred.reject(errorResponse)

    # Attempt to get a cached response for the storeKey/cacheKey combination, or
    # invoke funcToCall (with no arguments) if the object is not cached. maxAge
    # is the maximum age (in milliseconds) of the cached result, or null if
    # there is no max age.
    promiseCacheService.get = (storeKey, cacheKey, funcToCall, maxAge=null, cacheRejectedPromises = false) ->
      deferred = $q.defer()

      # If a response has already been cached, use that.
      if getCachedResponse(storeKey, cacheKey, maxAge, cacheRejectedPromises, deferred)
        return deferred.promise

      # Otherwise, if a query is pending, wait until that query returns and then
      # use the reponse.
      if getPendingQuery(storeKey, cacheKey, deferred)
        return deferred.promise

      # Otherwise, kick off a new query.
      callFunctionAndCacheResult(storeKey, cacheKey, funcToCall, deferred)
      return deferred.promise

    promiseCacheService

  ]
